<template>
  <fieldset class="form-input">
    <div class="textarea__label">
      <label
        v-if="label"
        class="txt--xs txt--semi-bold txt--off-white textarea__label--txt"
        :for="id"
        >{{ label }}</label
      >
      <span
        class="txt--xs txt--semi-bold txt--off-white txt__counter"
        v-if="charRequired"
        >{{ remaininigCount }}</span
      >
    </div>
    <div>
      <textarea
        v-if="charRequired"
        class="textArea"
        :maxlength="char_limit"
        :name="name"
        :id="id"
        :rows="rows"
        :placeholder="placeholder"
        v-model="currentValue"
      ></textarea>
      <textarea
        v-else
        class="textArea"
        :name="name"
        :id="id"
        :rows="rows"
        :placeholder="placeholder"
        v-model="currentValue"
      ></textarea>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: "Textarea",
  props: {
    name: {
      type: String,
      default: "",
    },
    id: {
      type: String,
      default: () => {
        return "toggle-" + Math.random().toString(36).substr(2, 9);
      },
    },
    label: {
      type: String,
      default: "",
    },
    rows: {
      type: Number,
      default: 3,
    },
    placeholder: {
      type: String,
      default: "Type here...",
    },
    char_limit: {
      type: Number,
      default: 200,
    },
    value: {
      type: String,
      default: "",
    },
    charRequired: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentValue: this.value,
    };
  },
  watch: {
    currentValue() {
      this.$emit("input", this.currentValue);
    },
  },
  computed: {
    remaininigCount() {
      if (this.charRequired) {
        return this.char_limit - this.currentValue.length;
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
.textarea__label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.textArea {
  border: 1px solid rgba(255, 255, 255, 0.5);
  width: 100%;
  padding: 20px;
  border-radius: 16px;
  background-color: transparent;
  resize: none;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.25);
  overflow-x: hidden;
  overflow-y: auto;
  -ms-overflow-style: none;
  transition: all ease-in-out 0.2s;
}

.textArea:focus {
  box-shadow: 0 0 6px 2px rgba(0, 123, 255, 0.25);
}

.textArea::-webkit-scrollbar {
  display: none;
}

.textArea::placeholder {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.25);
}
</style>